import { ADD_VIEW, REMOVE_VIEW } from './constants.js';

const reducerSettings = (state, action) => {
	const { type, views = [] } = action;

	switch (type) {
		case ADD_VIEW:
			return [...state, ...views.filter(item => !state.includes(item))];

		case REMOVE_VIEW:
			return [...state.filter(item => !views.includes(item))];

		default:
			throw new Error(`Unexpected error the type ${type} not exists`);
	}
};

export default reducerSettings;

/** Actions */
export function addView(...args) {
	return { type: ADD_VIEW, views: [...args] };
}

export function hideView(...args) {
	return { type: REMOVE_VIEW, views: [...args] };
}
